import { createApi } from "@reduxjs/toolkit/query/react"; 
import axiosBaseQuery from "../axiosBaseQuery"; 

const userApi = createApi({
    reducerPath: "base/users",
    baseQuery: axiosBaseQuery,
    tagTypes: ["Users"],
    endpoints: (builder) => ({
        fetchUsers: builder.query<any[], void>({
            providesTags: [{ type: "Users", id: "List" }],
            query: () => ({ url: '/base/users', method: 'GET' }) 
        }),
        addUser: builder.mutation({
            invalidatesTags: [{ type: "Users", id: "List" }],
            query: (user) => ({
                url: "/base/users",
                method: "POST",
                body: user
            })
        })
    })
});

// Export hooks
export const { useFetchUsersQuery, useAddUserMutation } = userApi;
export { userApi }
